import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FAC440" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.instagram.com/nenechickenca/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Nene Chicken Instagram"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/nenechickenontario/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Nene Chicken Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FAC440" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.instagram.com/nenechickenca/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Nene Chicken Instagram"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/nenechickenontario/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Nene Chicken Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
